import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { FlyoutDataType, FlyoutOpeningData, PersonDetails, Visit } from '../flyout-models';
import { Subscription } from 'rxjs';
import { FlyoutService } from '../flyout.service';

@Component({
  selector: 'app-flyout-sessions',
  templateUrl: './flyout-sessions.component.html',
  styleUrls: ['./flyout-sessions.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutSessionsComponent implements OnInit, OnDestroy {
  private readonly logger: Logger;
  private _openingData: FlyoutOpeningData;
  public personDetails: PersonDetails;
  private personSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];
  public visits: Array<Visit>;
  public visitsToShow: Array<Visit>;
  public index = 0;
  public spanStart: number;
  public spanEnd: number;
  @Input() public isMobile = false;

  @Input() public set flyoutOpeningData(openingData: FlyoutOpeningData) {
    this._openingData = openingData;
  }

  public get flyoutOpeningData(): FlyoutOpeningData {
    return this._openingData;
  }

  constructor(
    public readonly loggerFactory: LoggerFactory,
    private readonly flyoutService: FlyoutService,
  ) {
    this.logger = loggerFactory.get('FlyoutActionListComponent');
  }

  ngOnInit() {
    this.personSubscription = this.flyoutService.personDetailsBS.subscribe((personDetails: PersonDetails) => {
      this.personDetails = personDetails;
      this.processStatistics();
    });
  }

  private processStatistics() {
    if (this.personDetails && this.personDetails.visits) {
      this.visits = JSON.parse(JSON.stringify(this.personDetails.visits));
    } else {
      this.visits = [];
    }
    for (const visit of this.visits) {
      if (visit.utmSource) {
        visit.source = visit.utmSource;
      } else if (visit.referrerDomain && !visit.utmSource) {
        visit.source = visit.referrerDomain;
      } else {
        visit.source = 'Direct';
      }
    }
    this.spanStart = this.index + 1;
    this.spanEnd = this.index + 5;
    this.visitsToShow = this.visits.slice(this.index, this.index + 5);
  }

  public navigateVisits(add: boolean) {
    if (add && this.index < this.visits.length - 5) {
      this.index = this.index + 5;
    } else if (!add && this.index > 0) {
      this.index = this.index - 5;
    } else {
      return;
    }
    this.spanStart = this.index + 1;
    if (this.index < this.visits.length - 5) {
      this.spanEnd = this.index + 5;
    } else {
      this.spanEnd = this.visits.length;
    }
    this.visitsToShow = this.visits.slice(this.index, this.index + 5);
  }

  public openFlyoutForSession(sessionId: number, identifier: string, commitment: number) {
    this.flyoutService.open({
      type: FlyoutDataType.Session,
      sessionId: sessionId,
      siteId: this.flyoutOpeningData.siteId,
      identifier: identifier,
      commitment: commitment,
      widgets: this.flyoutService.getWidgetsList(),
      gravatarHash: this.flyoutOpeningData.gravatarHash,
    } as FlyoutOpeningData);
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.personSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
